import Paper from "@mui/material/Paper";
import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {TagCategory} from "../../gen/api";
import {FormLabel} from "@mui/material";

type Props = {
  handleAreasOfApplicationCheck: (tagId: string) => void
  areasOfApplication?: TagCategory
}

function EditAreasOfApplication({handleAreasOfApplicationCheck, areasOfApplication}: Props) {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleAreasOfApplicationCheck(event.target.value)
  }
  return (
      <Paper>
        <FormLabel required={true}>Empfohlener Einsatzbereich</FormLabel>
        <FormGroup>
          {areasOfApplication?.tags.map(tag =>
              <FormControlLabel key={tag.name} control={<Checkbox value={tag.id}
                                                                  checked={tag.selected}
                                                                  onChange={onChange}/>}
                                label={tag.name}/>
          )}
        </FormGroup>
      </Paper>
  );
}

export default EditAreasOfApplication;